import { API_ROOT_BARE, API_VERSION } from './constants';
import { normalize } from 'normalizr'
import get from 'lodash/get';
import sortBy from 'lodash/sortBy';

// Extracts the next page URL from API response.
const getNextPageUrl = response => {
  const link = response.headers.get('link');
  if (!link) {
    return null;
  }

  const nextLink = link.split(',').find(s => s.indexOf('rel="next"') > -1);
  if (!nextLink) {
    return null;
  }
  return nextLink.split(';')[0].slice(2, -1);
}

// Fetches an API response and normalizes the result JSON according to schema.
// This makes every API response have the same shape, regardless of how nested it was.
const callApi = (endpoint, schema, resultProp = null, requestInit = {}, sortByParams = null, transformResult, apiVersion) => {
  //const fullUrl = ((endpoint.indexOf(API_ROOT) === -1) ? API_ROOT + endpoint : endpoint);// + '?c=' + new Date().getTime();
  const fullUrl = ((endpoint.indexOf(API_ROOT_BARE) === -1 && !endpoint.startsWith('http')) ? `${API_ROOT_BARE}/${apiVersion}/${endpoint}` : endpoint) + (endpoint.indexOf('?') > -1 ? '&' : '?') + encodeURI(window.location.origin);
  const request = new Request(fullUrl, requestInit);
  
  return fetch(request)
    .then(response =>
      response.json().then(json => {
        if (!response.ok) {
          return Promise.reject(json);
        }
        const nextPageUrl = getNextPageUrl(response);

        let result = resultProp ? get(json, resultProp) : json;
        if(sortByParams) {
          try {
            result = sortBy(result, sortByParams)
          } catch(e) {}
        }
        if(transformResult) {
          try {
            result = transformResult(result)
          } catch(e) {
            
          }
        }

        return Object.assign({},
          //normalize(json, schema),
         // normalize(resultProp ? get(json, resultProp) : json, schema),
          normalize(result, schema),
          { nextPageUrl },
          { rawResponse: json }
        );
      })
    );
}
// Action key that carries API call info interpreted by this Redux middleware.
export const CALL_API = 'Call API';

// A Redux middleware that interprets actions with CALL_API info specified.
// Performs the call and promises when such actions are dispatched.
export default store => next => action => {
  const callAPI = action[CALL_API];
  if (typeof callAPI === 'undefined') {
    return next(action);
  }

  let { endpoint } = callAPI;
  const { schema, types, resultProp, requestInit, sortByParams, transformResult, apiVersion = API_VERSION} = callAPI;

  if (typeof endpoint === 'function') {
    endpoint = endpoint(store.getState());
  }

  if (typeof endpoint !== 'string') {
    throw new Error('Specify a string endpoint URL.');
  }
  if (!schema) {
    throw new Error('Specify one of the exported Schemas.');
  }
  // if (!Array.isArray(types) || types.length !== 3) {
  //   throw new Error('Expected an array of three action types.');
  // }
  if (!Array.isArray(types)) {
    throw new Error('Expected an array of action types.');
  }
  if (!types.every(type => typeof type === 'string')) {
    throw new Error('Expected action types to be strings.');
  }

  const actionWith = data => {
    const finalAction = Object.assign({}, action, data);
    delete finalAction[CALL_API];
    return finalAction;
  }

  const [requestType, successType, failureType] = types;
  next(actionWith({ type: requestType }));
  next(actionWith({ type: 'FETCH_SYNC_REQUEST' }));
/*
  return callApi(endpoint, schema, resultProp, requestInit, sortByParams).then(
    response => next(actionWith({
      response,
      type: successType
    })),
    error => next(actionWith({
      type: failureType,
      error: error.message || 'Something bad happened'
    }))
  );
*/
  return callApi(endpoint, schema, resultProp, requestInit, sortByParams, transformResult, apiVersion).then(
    response => {
      next(actionWith({
        response,
        type: successType
      }));
      setTimeout(() => {
        next(actionWith({ type: 'FETCH_SYNC_SUCCESS' }));
      });
    },
    error => {
      next(actionWith({
        type: failureType,
        error: error.message || 'Something bad happened'
      }));
      setTimeout(() => {
        next(actionWith({ type: 'FETCH_SYNC_FAILURE' }));
      });
    }
  );
}



// WEBPACK FOOTER //
// ./src/api/index.js